export const discountSize = (disc: string): string => {
  if (disc.length > 6) return "special";
  if (!disc.includes("%") && disc.length > 3) return "long-currency";
  return "";
};
